<template>
  <div
    class="menu-page-desktop"
    :class="{ 'menu-page-mobile': $route.meta.mobile }"
  >
    <h1>{{ $t("canals5d-partners.title") }}</h1>
    <p>
      {{ $t("canals5d-partners.p1") }}
    </p>

    <p>
      {{ $t("canals5d-partners.p2") }}
    </p>

    <p>
      {{ $t("canals5d-partners.p3") }}
    </p>

    <ul>
      <li>{{ $t("canals5d-partners.list-1-1") }}</li>
      <li>{{ $t("canals5d-partners.list-1-2") }}</li>
      <li>{{ $t("canals5d-partners.list-1-3") }}</li>
      <li>{{ $t("canals5d-partners.list-1-4") }}</li>
      <li>{{ $t("canals5d-partners.list-1-5") }}</li>
      <li>{{ $t("canals5d-partners.list-1-6") }}</li>
      <li>{{ $t("canals5d-partners.list-1-7") }}</li>
      <li>{{ $t("canals5d-partners.list-1-8") }}</li>
      <li>{{ $t("canals5d-partners.list-1-9") }}</li>
      <li>{{ $t("canals5d-partners.list-1-10") }}</li>
      <li>{{ $t("canals5d-partners.list-1-11") }}</li>
      <li>{{ $t("canals5d-partners.list-1-12") }}</li>
      <li>{{ $t("canals5d-partners.list-1-13") }}</li>
    </ul>

    <p>{{ $t("canals5d-partners.p4") }}</p>

    <div class="logos">
      <div class="logo-container">
        <a href="https://www.zuid-holland.nl/" target="_blank">
          <img src="../svg/Provincie-Zuid-Holland.svg" />
        </a>
      </div>

      <div class="logo-container">
        <a href="https://www.rotterdamfestivals.nl/" target="_blank">
          <img src="../svg/Rotterdam-Festivals.svg" />
        </a>
      </div>

      <div class="logo-container">
        <a href="https://www.cultuurfonds.nl/" target="_blank">
          <img src="../svg/Prins-Bernhard-Cultuurfonds-liggend.svg" />
        </a>
      </div>

      <div class="logo-container">
        <a href="https://www.erfgoedleiden.nl/" target="_blank">
          <img src="../svg/Erfgoed-Leiden-en-Omstreken.svg" />
        </a>
      </div>
    </div>

    <hr />
    <page-footer />
  </div>
</template>

<script>
import PageFooter from "@/components/menus/pages/PageFooter.vue";

export default {
  components: {
    PageFooter
  },
  head: {
    meta: [
      {
        name: "viewport",
        content: "width=device-width, shrink-to-fit=YES",
        initialScale: "1.0",
        maximumScale: "1.0",
        minimumScale: "1.0",
        userScalable: "no"
      }
    ]
  }
};
</script>

<style scoped src="../css/main.css"></style>
<style scoped src="../css/canals5d.css"></style>
